import { render, staticRenderFns } from "./ModalSign.vue?vue&type=template&id=baa04b84&"
import script from "./ModalSign.vue?vue&type=script&lang=js&"
export * from "./ModalSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baa04b84')) {
      api.createRecord('baa04b84', component.options)
    } else {
      api.reload('baa04b84', component.options)
    }
    module.hot.accept("./ModalSign.vue?vue&type=template&id=baa04b84&", function () {
      api.rerender('baa04b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalSign.vue"
export default component.exports